<template>
    <div v-if="visible">
        <b-alert show dismissible :variant="variant" :class="messageClasses">
            <em
                v-if="variant === 'info'"
                class="alert-icon fas fa-info-circle"
            ></em>
            <em
                v-if="variant === 'success'"
                class="alert-icon fas fa-check"
            ></em>
            <em
                v-if="variant === 'danger'"
                class="alert-icon fas fa-exclamation-circle"
            ></em>
            <em
                v-if="variant === 'warning'"
                class="alert-icon fas fa-exclamation-triangle"
            ></em>
            <div v-if="title && title.length > 0">
                <h4 class="alert-heading">{{ title }}</h4>
            </div>
            <p class="text" v-html="message" />
        </b-alert>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        computed: {
            ...mapState(['alertMessage']),
            message() {
                return this.alertMessage.message;
            },
            variant() {
                return this.alertMessage.variant;
            },
            visible() {
                return !!this.message;
            },
            title() {
                return this.alertMessage.title;
            },
            hasSearch() {
                return this.alertMessage.hasSearch;
            },
            adjustAlertWidth() {
                return this.alertMessage.adjustAlertWidth;
            },
            hasBlink() {
                return this.alertMessage.blink;
            },
            messageClasses() {
                const classes = {
                    'show-search': this.hasSearch,
                    'show-blink': this.hasBlink,
                    'has-buttons': this.adjustAlertWidth
                };
                if (this.alertMessage.alertClass) {
                    classes[this.alertMessage.alertClass] = true;
                }
                return classes;
            }
        }
    };
</script>

<style lang="scss">
.alert-dismissible .close {
    padding-top: 8px;
    padding-right: 12px;
    opacity: 1;
}
</style>

<style lang="scss" scoped>
.alert.show-blink {
    animation: blinkingBackground 0.5s linear 3;
}
@keyframes blinkingBackground {
    0% {
        background-color: $gray-03;
        opacity: 1;
    }

    50% {
        background-color: $gray-03;
        opacity: 0.5;
    }

    100% {
        background-color: $gray-03;
        opacity: 1;
    }
}
h4 {
    font-weight: normal;
    margin-left: 30px;
}

p {
    margin-bottom: 0;
}

.alert {
    @include margin-top-navbar-alert;
    position: absolute;
    display: flex;
    z-index: 9999;
    padding: 0.65rem;
    margin: 10px;
    box-sizing: border-box;
    border-radius: 4px;
    width: calc(100% - 20px);
}

.alert-info {
    color: $aqua-07;
    background-color: $aqua-01;
    border: 1px solid $aqua-03;
}

.alert-error {
    color: $redprune-07;
    background-color: $redprune-01;
    border: 1px solid $redprune-03;
}

.alert-success {
    color: $green-07;
    background-color: $green-01;
    border: 1px solid $green-03;
}

.alert-icon {
    position: absolute;
    margin-top: 2px;
}

.text {
    padding-left: 30px;
    font-size: 18px;
    white-space: pre-line;
}

.alert button + em + p {
    padding-right: 20px;
}

/*-------------------------------------
    min-width 600px - small devices (portrait tablets and large phones, 600px and up)
    ---------------------------------------*/
@media (min-width: 600px) {
    .alert {
        margin-left: 0px;
        width: 360px;
        left: 50%;
        transform: translate(-50%);
    }
}

/*-------------------------------------
    min-width 600px - mobile devices
    ---------------------------------------*/
@media (max-width: 600px) {
    .alert.has-buttons {
        width: calc(100% - 70px);
    }
}

/*-------------------------------------
    max-width : 767px
    ---------------------------------------*/
@media (max-width: 767px) {
    .text {
        font-size: 16px;
        padding-left: 25px;
    }
}

/*-------------------------------------
    max-width : 985px (when searchbar is reached)
    ---------------------------------------*/
@media (max-width: 985px) {
    .alert.show-search {
        @include margin-top-navbar-search;
    }
}
</style>
